import moment from 'moment';
import { snakeCase } from 'change-case';

import Base from 'app/views/base';
import ItemDetailsView from '../item_details';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .list__body__item__show_details': 'toggleDetails',
    'click .list__body__item__heading': 'clickHeading',
  },

  initialize({ headings = [], showDetails = false }) {
    this.headings = headings;
    this.showDetails = showDetails;
    this.uid = parseInt(Math.random() * 100000, 10);

    this.headings.forEach(heading => {
      if (heading.subView) {
        const subView = heading.subView(this.model);
        const id = this.model.get('id');
        const subviewName = this.computeHeadingId(id, heading.display);

        if (!this.getSubview(subviewName)) {
          this.addSubview(
            subviewName,
            `#${subviewName}`,
            subView
          );
        }
      }
    });
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    const createdDate = moment(this.model.get('created_at') || '').utc();

    return {
      model: this.model,
      headings: this.headings,
      created: createdDate.isValid() ? createdDate.format('YYYY-MM-DD HH:mm') : '',
      showDetails: this.showDetails,
      computeDetailsId: this.computeDetailsId.bind(this),
      computeHeadingId: this.computeHeadingId.bind(this),
      getTextFromHeading: this.getTextFromHeading,
    };
  },

  getTextFromHeading(model, heading) {
    if (heading.text) {
      if (typeof heading.text === 'function') {
        return heading.text(model);
      }

      return heading.text;
    }

    const prop = heading.property;

    if (typeof model[prop] === 'function') {
      return model[prop]();
    }

    return model.get(prop);
  },

  computeId(id) {
    return `${this.uid}-model-${id}`;
  },

  computeHeadingId(id, display) {
    return `${this.computeId(id)}-${snakeCase(display)}`;
  },

  computeDetailsId(id) {
    return this.computeId(id) + '-details';
  },

  toggleDetails(e) {
    e.preventDefault();

    const id = this.model.get('id');
    const subviewName = this.computeDetailsId(id);

    if (!this.getSubview(subviewName)) {
      this.addSubview(
        subviewName,
        `#${subviewName}`,
        new ItemDetailsView({ model: this.model, showDetails: this.showDetails })
      );

      this.render();
    }

    this.$('.list__body__item__details').toggle();
  },

  clickHeading(e) {
    const headingIndex = $(e.currentTarget).data().headingIndex;

    if (this.headings[headingIndex].onClick) {
      e.preventDefault();
      this.headings[headingIndex].onClick(this.model);
    }
  }
});



// WEBPACK FOOTER //
// ./app/components/list/item/index.js